var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLeft,
            expression: "showLeft",
          },
        ],
        staticClass: "left_tree",
      },
      [
        _c(
          "a-spin",
          {
            staticStyle: { height: "100%" },
            attrs: { spinning: _vm.treeSpin },
          },
          [
            _c(
              "div",
              [
                _c(
                  "a-radio-group",
                  {
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [
                    _c("a-radio-button", { attrs: { value: "dept" } }, [
                      _vm._v(" 部门 "),
                    ]),
                    _c("a-radio-button", { attrs: { value: "customer" } }, [
                      _vm._v(" 员工 "),
                    ]),
                  ],
                  1
                ),
                _c(
                  "vxe-button",
                  {
                    staticStyle: { "margin-top": "12px" },
                    on: { click: _vm.closeAll },
                  },
                  [_vm._v("清空")]
                ),
              ],
              1
            ),
            _vm.type === "dept"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c(
                      "a-tree",
                      {
                        attrs: {
                          "show-icon": true,
                          checkable: "",
                          "expanded-keys": _vm.expandedKeys,
                          "auto-expand-parent": _vm.autoExpandParent,
                          "selected-keys": _vm.selectedKeys,
                          "tree-data": _vm.treeData,
                          selectable: false,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                          },
                        },
                        on: { expand: _vm.onExpand, check: _vm.onSelect },
                        model: {
                          value: _vm.checkedKeys,
                          callback: function ($$v) {
                            _vm.checkedKeys = $$v
                          },
                          expression: "checkedKeys",
                        },
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { color: "#2fcfeb" },
                          attrs: { slot: "dealer", type: "team" },
                          slot: "dealer",
                        }),
                        _c("a-icon", {
                          staticStyle: { color: "#52c41a" },
                          attrs: { slot: "region", type: "cluster" },
                          slot: "region",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "customer"
              ? _c(
                  "div",
                  { staticClass: "tree-box" },
                  [
                    _c("Tree", {
                      attrs: {
                        list: _vm.treeData,
                        selectedUser: _vm.selectedUser,
                        userName: "",
                        detph: 0,
                      },
                      on: { change: _vm.checkedUser },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "right_table", class: { showLeft: !_vm.showLeft } },
      [
        _vm.showLeft
          ? _c("a-icon", {
              staticClass: "close",
              attrs: { type: "left-circle" },
              on: {
                click: function ($event) {
                  _vm.showLeft = false
                },
              },
            })
          : _c("a-icon", {
              staticClass: "close",
              attrs: { type: "right-circle" },
              on: {
                click: function ($event) {
                  _vm.showLeft = true
                },
              },
            }),
        _c("x-grid", {
          ref: "grid",
          attrs: {
            id: "formList",
            rowId: _vm.rowId,
            "pager-config": _vm.pagerConfig,
            "form-config": _vm.formConfig,
            url: _vm.url,
            columns: _vm.columns,
            "checkbox-config": _vm.checkboxConfig,
            "toolbar-config": _vm.toolbarConfig,
            "print-config": _vm.printConfig,
            "export-config": _vm.exportConfig,
            cellClick: _vm.chooseRow,
            cellDbClick: _vm.updateRow,
            "other-params": {
              "filter.orderByDesc.createDate": true,
              regionId: _vm.regionId,
              dealerId: _vm.dealerId,
              deptId: _vm.deptId,
              userId: _vm.userId,
            },
          },
          on: { "toolbar-addData": _vm.addRow, "toolbar-delData": _vm.delRow },
        }),
        _c(
          "formModal",
          {
            attrs: {
              title: "活动报账详情",
              centered: "",
              closable: true,
              footer: null,
              maskClosable: false,
              visible: _vm.editModalVisible,
              width: 1040,
            },
          },
          [
            _vm.editModalVisible
              ? _c("detailForm", {
                  ref: "detailForm",
                  attrs: { rowId: _vm.editRowId, actId: _vm.chooseActId },
                  on: {
                    cancelled: function ($event) {
                      return _vm.closeEdit()
                    },
                    saved: function ($event) {
                      return _vm.closeEdit(true)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "选择活动",
              centered: "",
              footer: null,
              maskClosable: true,
              width: 1200,
              closable: true,
            },
            model: {
              value: _vm.showActPop,
              callback: function ($$v) {
                _vm.showActPop = $$v
              },
              expression: "showActPop",
            },
          },
          [
            _vm.showActPop
              ? _c("actList", {
                  ref: "actList",
                  on: { close: _vm.closeTransferPop, chooseAct: _vm.chooseAct },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }